import "../style/azmoon-list/AL_Filter.css";
import { HiOutlineFilter } from "react-icons/hi";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";
import { useEffect } from "react";
import React from "react";

let data_list = [
  {
    id: 1,
    tag: "همه",
    isActive: true,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "all",
  },
  {
    id: 2,
    tag: "پایه تحصیلی",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "level",
  },
  {
    id: 3,
    tag: "در حال برگزاری",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "live",
  },
  {
    id: 4,
    tag: "دانشگاهی",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type:"collegiate",
  },
];

const AL_Filter = () => {
  const [data, set_data] = useState(data_list);
  const [al_oldActive, set_al_oldActive] = useState(1);
  // console.log("al-filter------run");

  // باید عوض شود
  const dispatch = useDispatch();
  const { ExamChangeFilter } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    for (let i = 0; i < data_list.length; i++) {
      if (i === 0) {
        data_list[0].isActive = true;
      } else {
        data_list[i].isActive = false;
      }
    }
    set_data(data_list);
    ExamChangeFilter("all");
  }, []);

  const changer_filter = (id) => {
    let new_data = data.map((item) => {
      if (item.id === al_oldActive) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
        ExamChangeFilter(item.type);
      }
      return { ...item };
    });
    set_al_oldActive(id);
    set_data(new_data);
  };

  return (
    <div className="al-filter">
      <div className="al-filter-title-box">
        <HiOutlineFilter className="alftb-icon" />
        <div className="alftb-title">دسته‌بندی</div>
      </div>
      <div className="al_filter_tag_container">
        {data.map((item) => (
          <div
            style={item.isActive ? item.style : null}
            key={item.id}
            className="alftc-item"
            onClick={() => changer_filter(item.id)}
          >
            {item.tag}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AL_Filter;
